import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { HelperService } from '../helper/helper.service';
import {
  fetchBanners,
  fetchBanner,
  fetchFilteredBanners,
  addBanner,
  updateBanner,
  deleteBanner, fetchBannerSuccess
} from '../../store/banner/banner.actions';
import { getBannersSelector, getBannerSelector, getBannersSelectorchanel, getBannersPagination } from '@store/banner/banner.selectors';
import { IPagination, IState } from '@models/index';
import { SharedService } from '@services/shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  backendUrl = environment.backendUrl;

  private _clickSaved = new Subject<boolean>();
  clickSaved$ = this._clickSaved.asObservable();

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private store: Store<{ banner: IState }>
  ) {}

  onClickSavedToggle(clicked: boolean) {
    this._clickSaved.next(clicked);
  }

  getBannersSelector(): Observable<IState> {
    return this.store.select(getBannersSelector);
  }

  getBannersSelectorforcampaign(): Observable<any[]> {
    return this.store.select(getBannersSelectorchanel);
  }

  getBannersSelectorPAgination(): Observable<IPagination> {
    return this.store.select(getBannersPagination);
  }

  getBannerSelector(): Observable<any> {
    return this.store.select(getBannerSelector);
  }

  fetchBanners(page, filterOptions) {
    this.store.dispatch(fetchBanners({ page, filterOptions }));
  }

  fetchFilteredBanners(page, filterOptions) {
    this.store.dispatch(fetchFilteredBanners({ page, filterOptions }));
  }

  fetchBanner(id) {
    this.store.dispatch(fetchBanner({ id }));
  }

  addBanner(banner) {
    this.sharedService.onLoaderToggle(true);
    this.store.dispatch(addBanner({ banner }));
  }

  updateBanner(banner) {
    this.sharedService.onLoaderToggle(true);
    this.store.dispatch(updateBanner({ banner }));
  }

  deleteBanner(id) {
    this.store.dispatch(deleteBanner({ id }));
  }

  getBanners(page: number, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/promotion-tools?${queryString}`);
  }

  getBanner(id) {
    return this.http.get(`${this.backendUrl}/promotion-tools/promotion-tool/${id}`);
  }

  getUrl(bannerId: number){
    return `${this.backendUrl}/promotion-tools/promotion-tool/${bannerId}/generate`;
  }

  insertBanner(banner) {
    return this.http.post(`${this.backendUrl}/promotion-tools/promotion-tool`, banner);
  }

  renewBanner(banner) {
    return this.http.patch(`${this.backendUrl}/promotion-tools/promotion-tool/${banner.id}`, banner)
  }

  removeBanner(id) {
    return this.http.delete(`${this.backendUrl}/promotion-tools/promotion-tool/${id}`);
  }

  setSelectBanner(banner: {}) {
    this.store.dispatch(fetchBannerSuccess({banner}));
  }
}
